import { render } from "./ActivityPoster.vue?vue&type=template&id=02e60da0&scoped=true"
import script from "./ActivityPoster.vue?vue&type=script&lang=js"
export * from "./ActivityPoster.vue?vue&type=script&lang=js"

import "./ActivityPoster.vue?vue&type=style&index=0&id=02e60da0&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e60da0"]])

export default __exports__